// eslint-disable-next-line no-console
console.log('BackOffice service worker loaded');

// eslint-disable-next-line no-restricted-globals
if (self.importScripts) {
  // eslint-disable-next-line no-restricted-globals
  self.importScripts('https://s3-eu-west-1.amazonaws.com/static.wizrocket.com/js/sw_webpush.js');
}
